// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const AssetLifecycleStateOriginSchema = z.enum(['SCOPING','MANUAL','CODE'] as const);

export type AssetLifecycleStateOriginType = `${z.infer<typeof AssetLifecycleStateOriginSchema>}`

export default AssetLifecycleStateOriginSchema;
